import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import { ThemeOverride } from '@chakra-ui/react';

export const sliderStyles: ThemeOverride = {
  components: {
    RangeSlider: {
      variants: {
        main: (props: StyleFunctionProps) => ({
          thumb: {
            bg: mode('brand.500', 'brand.400')(props),
          },
        }),
      },
    },
  },
};
